import { Navbar, Image } from "react-bootstrap";
import styled from "styled-components";

export const NavWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1050;
  background: #ffffff;
  box-shadow: 0 3px 10px rgba(0,0,0,0.08);
`;

export const TopNavbar = styled(Navbar)`
  height: 65px;
  padding: 0 25px;
  background-color: #ffffff !important;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .navbar-nav .nav-link, 
  .navbar-nav .dropdown-toggle {
    color: #2f3542 !important;
    font-weight: 500;
    padding: 10px 18px !important;
    transition: 0.2s ease;
  }

  .navbar-nav .nav-link:hover,
  .navbar-nav .dropdown-toggle:hover {
    color: #1e90ff !important;
  }
`;

export const Logo = styled(Image)`
  width: 100px;
  height: auto;
  border-radius: 6px;
  margin-left: 30px;
`;

export const NotiLink = styled.a`
  position: relative;
  color: #2f3542 !important;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;

  &:hover {
    color: #1e90ff !important;
  }
`;

export const Badge = styled.span`
  background: #ff4757;
  color: white;
  font-size: 12px;
  padding: 2px 7px;
  border-radius: 12px;
  margin-left: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const BrandTitle = styled.h2`
  font-size: 22px;
  font-weight: 800;
  color: #112557;
  margin: 0;
  padding: 0;
  letter-spacing: 0.7px;

  position: relative;
  padding-left: 14px;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 4px;
    width: 6px;
    height: 80%;
    background: #0d6efd;
    border-radius: 4px;
  }
`;

